import { FC, ReactNode } from 'react'
import { Box } from '@mui/material'
import { LoadedSpinner } from '$components/common'
import { TeamOnboardingProvider } from '@loadedhub/team-onboarding-management'
import { useAppContextReady } from '$hooks'
import { appConfig, getActiveCompany, getAuthToken } from '$utils'

type TeamOnboardingWidgetProviderProps = {
  children: ReactNode
}

/**
 * Wraps team-onboarding-management widgets in the TeamOnboardingProvider, supplying auth
 * and API config the same way for every consumer. Renders a spinner until the
 * app context (active company) is ready.
 */
const TeamOnboardingWidgetProvider: FC<TeamOnboardingWidgetProviderProps> = ({
  children,
}) => {
  const appContextReady = useAppContextReady()

  const userJwt = getAuthToken()
  const companyId = appContextReady ? getActiveCompany()?.id : undefined
  const apiBaseUrl = appConfig.get<string>('onboardingApiUrl')
  const canRender = !!userJwt && !!companyId && appContextReady && !!apiBaseUrl

  if (!canRender) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', padding: 3 }}>
        {!appContextReady && <LoadedSpinner size={24} />}
      </Box>
    )
  }

  return (
    <TeamOnboardingProvider
      apiBaseUrl={apiBaseUrl}
      userJwt={userJwt}
      companyId={String(companyId)}
    >
      {children}
    </TeamOnboardingProvider>
  )
}

export default TeamOnboardingWidgetProvider
